import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { TogglePartnerRequestUseCaseInterface } from 'domain/usecases';

export class RemoteTogglePartnerRequest implements TogglePartnerRequestUseCaseInterface {
  constructor(
    private readonly baseUrl: string,
    private readonly httpClient,
  ) {}

  async execute(params: { id: number }): Promise<TogglePartnerRequestUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.baseUrl}/${params.id}/toggle`,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
